(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-eu-guarantee]');
  if (!root) return;

  const trigger = root.querySelector('.eu-legal-guarantee__trigger');
  const dialog = root.querySelector('.eu-legal-guarantee__dialog');
  const closeButton = root.querySelector('[data-eu-guarantee-close]');

  if (!trigger || !dialog || !closeButton) return;

  trigger.addEventListener('click', () => dialog.showModal());
  closeButton.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
